// AUTO-GENERATED by scripts/gen-collection-covers.mjs — do not edit by hand.
// The set of collection cover slugs that actually have a /images/collections/<slug>.webp
// file. Collections whose slug is NOT in this set are hidden from the frontend
// (see hasCollectionCover in lib/collection-image.ts) so no coverless collection
// renders. Regenerate after adding covers: node scripts/gen-collection-covers.mjs
export const COLLECTION_COVER_SLUGS: ReadonlySet<string> = new Set([
  "90s-nostalgia",
  "adult-animation",
  "adult-swim-modern-toons",
  "after-dark",
  "animal-internet",
  "anime-deep-cut",
  "anime-essentials",
  "anime-universe",
  "anime-vault",
  "asmr-toolkit",
  "away-message-era",
  "battle-droids-pack",
  "battle-royale-pack",
  "bikini-bottom-broadcasts",
  "block-world-pack",
  "bluey-pals",
  "boot-screen-gallery",
  "boot-up-victory-pack",
  "brainrot-central",
  "car-life-pack",
  "celebration-hype",
  "certified-viral",
  "cinematic-tesla",
  "classic-cartoons",
  "classic-combat",
  "classic-tv-movies",
  "classic-vine-reactions",
  "comedy-gold",
  "comedy-sound-kit",
  "cult-movie-clips",
  "desi-bangers",
  "disney-friends-pack",
  "dj-drops-viral-beats",
  "drama-stings-thriller-drops",
  "ev-garage",
  "f1-paddock",
  "fail-sounds",
  "five-nights-pack",
  "fps-callouts",
  "future-worlds",
  "game-show-moments",
  "gaming-icons",
  "gaming-nostalgia",
  "gen-z-chronically-online",
  "goal-horns-big-calls",
  "guilty-pleasures",
  "hip-hop-drop",
  "holiday-hits",
  "horror-spooky",
  "horror-suspense",
  "iconic-music-moments",
  "icons-anthems",
  "international-meme-moment",
  "internet-legends",
  "jarvis-tesla-lock-sound",
  "kids-channel-classics",
  "late-night-internet",
  "late-night-scares",
  "laugh-track-legends",
  "main-character-mode",
  "marvel-friends",
  "meme-legends",
  "meme-miscellany",
  "meme-sounds",
  "mobile-gaming-hits",
  "mobile-mayhem",
  "most-popular",
  "movie-door-locks",
  "movie-moments",
  "nature-animals",
  "night-drive",
  "nintendo-handheld-hits",
  "nintendo-universe",
  "nostalgia-unlocked",
  "notification-alerts",
  "notification-overload",
  "odd-hours-playlist",
  "old-school-legends",
  "on-the-road",
  "open-world-chaos",
  "pixar-moments",
  "pok-mon-universe",
  "portal-turret-pack",
  "prestige-drama-pack",
  "pure-internet-energy",
  "quiet-lock-sounds",
  "quotable-movies",
  "quote-creatures",
  "reaction-pack",
  "reaction-roulette",
  "reality-tv-chaos",
  "retro-os-game-victory-lock-chimes",
  "ringtone-museum",
  "rizz-pack",
  "robot-ai-voices",
  "saturday-morning-cartoons",
  "saturday-morning-legends",
  "sci-fi-classics",
  "sci-fi-icons",
  "sci-fi-vault",
  "scifi-classics",
  "sega-zone",
  "sfx-toolkit",
  "spider-man-sounds",
  "sports-arena",
  "sports-celebrations",
  "stadium-anthems",
  "stadium-noise-pack",
  "star-wars-tesla",
  "streamer-culture",
  "super-mario-pack",
  "tech-retro",
  "tesla-essentials",
  "the-50-best-tesla-lock-sounds",
  "the-simpsons-pack",
  "tiktok-brain-rot",
  "troll-classics",
  "tron-mode",
  "tv-classics",
  "tv-moments",
  "valve-games",
  "villain-entrance",
  "viral-hits",
  "viral-music-moments",
  "whisper-mode",
  "windows-nostalgia",
  "wwe-legends",
  "y2k-online",
  "you-know-this-sound",
]);

// Slugs that additionally ship a <slug>-dark.webp. Only the line-drawn covers
// need one: they are ink on transparent, so a single file cannot serve both
// canvases. The older full-colour covers carry their own ground and render
// unchanged in either theme.
export const COLLECTION_COVER_DARK_SLUGS: ReadonlySet<string> = new Set([
  "anime-universe",
  "classic-tv-movies",
  "gaming-nostalgia",
  "horror-suspense",
  "sports-arena",
  "tech-retro",
]);
